module.exports = __webpack_public_path__ + "img/undTooth5.b4d53bf7.png";